export default __webpack_public_path__ + "static/media/Covered Call.43bc79b3.svg";